import { render, staticRenderFns } from "./NoData.vue?vue&type=template&id=09ba6815&scoped=true&"
var script = {}
import style0 from "./NoData.vue?vue&type=style&index=0&id=09ba6815&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ba6815",
  null
  
)

export default component.exports